import { useState } from "react";
import api from "../../../../services/api";
import message from "../../../../services/helper/message";
import i18n from "../../../../services/i18n";
import ChoseBase from "./bases";
import ForgotCode from "./code";
import ForgotConfirmation from "./confirmation";
import ForgotEmail from "./email";

export default function ForgotPassword() {

    console.log('rendering')

    const [step, setStep] = useState(0);
    const [code, setCode] = useState(null);
    const [email, setEmail] = useState(null);

    const [bases, setBases] = useState([]);
    const [selectedBase, setSelectedBase] = useState(null);

    const [loading, setLoading] = useState(false);

    const [errorForgot, setErrorForgot] = useState(null);
    const [errorConfirm, setErrorConfirm] = useState(null);


    async function handleGetCompanies(event) {
        try {
            setLoading(true);
            event.preventDefault();
            const email = document.getElementById('email').value;
            setEmail(email)
            const { data } = await api.get(`/company/email/${email}?all=true`);
            setBases(data)
            setStep(1);
        } catch (error) {
            message.error(error.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    async function handleForgot(baseId) {
        try {
            setLoading(true);

            const lang = i18n.language.split('-')[0];


            await api.post(`/users/recovery`, {
                baseId,
                email,
                lang
            });
            setStep(2);
        } catch (error) {
            message.error(error.response.data.message);
        } finally {
            setLoading(false);
        }

    }

    function handleCode() {
        setCode(document.getElementById('code').value);
        setStep(3)
    }

    async function handleConfirm(event) {

        try {
            event.preventDefault();
            setLoading(true);
            var newpass = document.getElementById('newPassword').value;


            await api.post(`/users/change`, {
                unique: code,
                newpass
            })
            message.sucess(i18n.t('successChanged'))

        } catch (error) {
            message.error(error.response.data.message);
        } finally {
            setLoading(false);
        }

    }

    function handlePrev() {
        setStep(value => value - 1);
    }


    if (step === 0) return (
        <ForgotEmail
            onSubmit={handleGetCompanies}
            error={errorForgot}
            loading={loading}
        />
    )
    else if (step === 1) return (
        <ChoseBase
            onSubmit={handleForgot}
            prevs={handlePrev}
            loading={loading}
            bases={bases}
            selectedBase={selectedBase}
            setSelectedBase={setSelectedBase}
        />
    )
    else if (step === 2) return (
        <ForgotCode
            onSubmit={handleCode}
            prevs={handlePrev}
            loading={loading}
        />
    )
    else if (step === 3) return (
        <ForgotConfirmation
            onSubmit={handleConfirm}
            prevs={handlePrev}
            error={errorConfirm}
            loading={loading}
        />
    )

}